// Client-side heuristic: encrypted PDFs carry an /Encrypt entry in their
// trailer. We scan the head + tail bytes so multi-MB files stay fast. The
// backend re-verifies with pypdf, so a rare false positive is harmless.
export async function pdfLooksEncrypted(file) {
  if (!file || !/\.pdf$/i.test(file.name || "")) return false;
  try {
    const dec = new TextDecoder("latin1");
    const head = dec.decode(new Uint8Array(await file.slice(0, 2 * 1024 * 1024).arrayBuffer()));
    if (head.includes("/Encrypt")) return true;
    const tailStart = Math.max(0, file.size - 65536);
    const tail = dec.decode(new Uint8Array(await file.slice(tailStart).arrayBuffer()));
    return tail.includes("/Encrypt");
  } catch (_) {
    return false;
  }
}
